import { changeDateFormatJavaToUi } from "@shared/common-functions/utility";

export interface InterplanReleaseDateData{
    "interplanReleaseDatesId" : number,
    "usInterplanReleaseDatesId" : number,
    "postProdSchedId" : number|null,
    "projectId" : number,
    "psrTitle" : string,
    "territoryId": number|any,
    "currentTerritory" : string,
    "interplanReleaseId" : number,
    "psrIntlReleaseDate" : Date|string,
    "psrUSReleaseDate" : Date|string,
    "interplanUSReleaseDate" : Date|string,
    "interplanIntlReleaseDate" : Date|string,
    "latestTerritory" : string,
    "viewedFlag" : boolean,
    "synchedFlag" : boolean,
    "usSynchedFlag" : boolean,
    "synchedDate" : Date|string,
    "updatedDate" : Date|string
    "projectAkas" :string[]|null;
}

export interface InterplanReleaseDateDataUi{
    data:InterplanReleaseDateData[];
    synchedData:InterplanReleaseDateData[];
    synchedUsData:InterplanReleaseDateData[];
    synchedIntlData:InterplanReleaseDateData[];
}

export let MangeReleaseTableHeaderData:string[]=[
    "Title",
    "MPG PSR Int'l Date",
    "Current Territory",
    "Interplan Int'l Date",
    "Latest Territory",
    "MPG PSR US Date",
    "Interplan US Date",
]


export function interplanReleaseDataServiceToUi(sData:InterplanReleaseDateData[]){
    let res:InterplanReleaseDateDataUi={
        data:[],
        synchedData: [],
        synchedUsData: [],
        synchedIntlData: [],
    }

    if(!sData?.length)
        return res;
    
    
    for(let s of sData){

        let temp:InterplanReleaseDateData={
            interplanReleaseDatesId: s.interplanReleaseDatesId,
            postProdSchedId: s.postProdSchedId,
            projectId: s.projectId,
            psrTitle: s.psrTitle,
            territoryId: s.territoryId,
            currentTerritory: s.currentTerritory,
            interplanReleaseId: s.interplanReleaseId,
            psrIntlReleaseDate: changeDateFormatJavaToUi(s.psrIntlReleaseDate,'mm/dd/yy'),
            psrUSReleaseDate:  changeDateFormatJavaToUi(s.psrUSReleaseDate,'mm/dd/yy'),
            interplanUSReleaseDate:  changeDateFormatJavaToUi(s.interplanUSReleaseDate,'mm/dd/yy'),
            interplanIntlReleaseDate:  changeDateFormatJavaToUi(s.interplanIntlReleaseDate,'mm/dd/yy'),
            latestTerritory: s.latestTerritory,
            viewedFlag: s.viewedFlag,
            synchedFlag: s.synchedFlag,
            synchedDate: s.synchedDate,
            updatedDate: s.updatedDate,
            projectAkas: s.projectAkas,
            usInterplanReleaseDatesId: s.usInterplanReleaseDatesId,
            usSynchedFlag: s.usSynchedFlag
        }

        let isIntlSyched=false;
        
        if(temp.interplanIntlReleaseDate==temp.psrIntlReleaseDate){
            res.synchedIntlData.push(temp);
            isIntlSyched=true;
        }

        if(temp.interplanUSReleaseDate==temp.psrUSReleaseDate){
            res.synchedUsData.push(temp);
            if(isIntlSyched)
                res.synchedData.push(temp);
        }
        
        res.data.push(temp);
    }

    return res;
}